import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useFeatureAccess } from '../../hooks/useFeatureAccess';

interface FeatureGuardProps {
  feature: string;
  children: ReactNode;
}

export const FeatureGuard = ({ feature, children }: FeatureGuardProps) => {
  const location = useLocation();
  const { hasFeature } = useFeatureAccess();

  if (!hasFeature(feature)) {
    const params = new URLSearchParams();
    params.set('feature', feature);
    params.set('source', 'feature-guard');
    params.set('from', location.pathname);

    return <Navigate to={`/plano-bloqueado?${params.toString()}`} replace />;
  }

  return <>{children}</>;
};
